import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import store from '@/store/index'
Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
	{
		path: '/',
		name: 'Login',
		component: () => import('../authorization/login/views/TheLogin'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('../authorization/register/views/TheRegister'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/register-verify-otp',
		name: 'RegisterVerifyOtp',
		component: () => import('../authorization/register/views/RegisterVerifyOtp'),
		meta: {
			auth: false,
		},
	},
	{
		path: '*',
		name: 'The404Page',
		component: () => import('../components/The404Page.vue'),
	},
	{
		path: '/change-password',
		name: 'ChangePassword',
		component: () => import('../modules/changePassword/views/ChangePassword.vue'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/goal',
		name: 'Goal',
		component: () => import('../modules/goal/views/GoalList'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/forgot-password',
		name: 'ForgotPassword',
		component: () => import('../authorization/resetPassword/views/ForgotPassword'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/verify-otp',
		name: 'ForgotVerifyOtp',
		component: () => import('../authorization/resetPassword/views/ForgotVerifyOtp'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/set-password',
		name: 'SetPassword',
		component: () => import('../authorization/resetPassword/views/SetPassword'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/goal/:id/products',
		name: 'GoalProducts',
		component: () => import('../modules/goal/views/GoalSuggestProduct'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/product-detail/:id',
		name: 'GoalProductDetail',
		component: () => import('../modules/goal/views/GoalProductDetail'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/checkout',
		name: 'checkout',
		component: () => import('@/modules/checkout/views/Checkout.vue'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/checkout-payment',
		name: 'checkout-payment',
		component: () => import('@/modules/checkout/views/CheckPayment.vue'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/payment/success',
		name: 'payment',
		component: () => import('@/modules/checkout/views/PaymentSuccess.vue'),
		meta: {
			auth: true,
		},
	},

	{
		path: '/cart',
		name: 'cart',
		component: () => import('@/modules/cart/views/Cart.vue'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/product',
		name: 'Product',
		component: () => import('@/modules/products/views/ProductList.vue'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/product/:id',
		name: 'ProductId',
		component: () => import('@/modules/products/views/ProductList.vue'),
		meta: {
			auth: false,
		},
	},
	{
		path: '/orders',
		name: 'Order',
		component: () => import('@/modules/orders/views/OrderList.vue'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/order-detail/:id',
		name: 'OrderDetail',
		component: () => import('@/modules/orders/views/OrderDetail.vue'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/me',
		name: 'profile',
		component: () => import('@/modules/profile/views/TheProfile.vue'),
		meta: {
			auth: true,
		},
	},
	{
		path: '/download-app',
		name: 'download-app',
		component: () => import('@/modules/downloadApp/views/DownloadApp.vue'),
		meta: {
			auth: false,
		},
	},
]

const router = new VueRouter({
	routes,
	mode: 'history',
})
router.beforeEach((to, from,next) => {
	const isLogin =localStorage.getItem('isLogin')
	if (to.name == 'Login') {
		if (isLogin) {
			next({ name: 'Goal' })
		}
	}
	if (to.name == 'payment') {
		if (localStorage.getItem('sessionId') === null) {
			next({ name: 'Goal' })
		}
	}
	if (to.name == 'checkout' || to.name == 'checkout-payment') {
		if (store.state.cartProducts.length == 0) {
			next({ name: 'cart' })
		}
	}
	if (to && to.meta && to.meta.auth) {
		if (isLogin) {
			next()
		} else {
			window.location.href = '/'
			return false
		}
	} else next()
	// ...
})
export default router
